import { styled, useMediaQuery, useTheme } from '@mui/material'
import { getAuth } from 'firebase/auth'
import { useEffect } from 'react'
import ViewTitle from '../../../components/ViewTitle'
import RestoreSession from '../../RestoreSession'
import PlansV1 from '../components/plans/PlansV1'
import Benefits from './components/Benefits'
import Blocks from './components/Blocks'
import Carousel from './components/Carousel'
import Devices from './components/Devices'
import Disclaimer from './components/Disclaimer'

/**
 * Renders primary homepage
 */

const StyledMain = styled('main')(({ theme }) => ({
  maxWidth: theme.breakpoints.values.xl,
  margin: '0 auto'
}))

export default function Homepage() {
  const userId = getAuth().currentUser?.uid
  const theme = useTheme()
  const isMediumOrUp = useMediaQuery(theme.breakpoints.up('md'))

  // Scroll to plans section when redirected to homepage
  useEffect(() => {
    if (!window.location.hash.includes('plansBlock')) {
      return
    }

    const plansElement = document.getElementById('plansBlock')
    if (plansElement) {
      const offset = isMediumOrUp ? -250 : -300 // pixels to scroll up from the element
      const elementPosition = plansElement.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  }, [isMediumOrUp])

  if (userId) {
    return <RestoreSession />
  }

  return (
    <>
      <ViewTitle title="Photo Storage" />
      <StyledMain>
        <Carousel />
        <PlansV1 />
        <Devices />
        <Blocks />
        <Benefits />
        <Disclaimer />
      </StyledMain>
    </>
  )
}
